export default __webpack_public_path__ + "static/media/new-view-remote.95b4eab7.png";